import Select from "react-select";
import { useEffect, useState } from "react";
import { apiUrl } from "../../utils/endPoints/apiUrl";
import { apiRequest } from "../../utils/config/apiRequest";

const AdminDetails = ({ formikProp }) => {
  const { values, errors, touched, setFieldValue } = formikProp;
  const [staffListOption, setStaffListOption] = useState([]);

  const fetchStaff = async (shopId) => {
    try {
      const { data, status } = await apiRequest({
        endUrl: apiUrl.staff.shopStaff,
        query: { shopId },
      });

      if (status) {
        const options =
          data?.rows?.map((item) => ({
            label: item?.staffId?.userName,
            value: item?.staffId?._id,
          })) || [];

        setStaffListOption(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (values.shopId) {
      fetchStaff(values.shopId);
    } else {
      setStaffListOption([]); 
      setFieldValue("staffId", "");
    }
  }, [values.shopId]);

  return (
    <div className="col-md-4">
      <div className="card">
        <div className="card-header">
          <h5 className="mb-0">
            <button className="btn btn-link text-black shadow-none pl-0 pb-0">
              Select Sub Admin
            </button>
          </h5>
        </div>

        <div className="card-body">
          <div className="form-group">
            <Select
              classNamePrefix="react-select"
              name="staffId"
              options={staffListOption}
              value={
                staffListOption.find(
                  (option) => option.value === values.staffId
                ) || null
              }
              onChange={(selectedOption) =>
                setFieldValue("staffId", selectedOption?.value || "")
              }
              placeholder="Select Staff..."
              isClearable
            />

            {touched?.staffId && errors?.staffId && (
              <span style={{ fontSize: 14, color: "red" }}>
                {errors.staffId}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDetails;
